import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { CommonService } from '../../../../services/common/common.service';
import { EventsDataService, EventsColumnsService, CategoriesEventDataService, ApplicationsDataService } from '../../../services';
import { Event, EventsResult, CategoriesResult } from '../../../interfaces';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorService } from '../../../../services/editor/editor.service';

@Component({
  selector: 'app-post-form',
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class EventFormComponent implements OnInit {

  public event: Event = {};
  public eventForm: FormGroup = new FormGroup({});
  public events: Event[] = [];
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'fr';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;
  public categories:any;
  selectedFile: File | null;
  selectedVideo: File | null;

  public Editor = ClassicEditor;
  categoryValue: any;
  formData = new FormData();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private messageService: MessageService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private eventsDataService: EventsDataService,
    public eventsColumnsService: EventsColumnsService,
    public editorService: EditorService,
    public categoriesDataService: CategoriesEventDataService,
    public applicationsDataService: ApplicationsDataService
  ) {
    this.selectedFile = null; // Initialize it to a default value, such as null
    this.selectedVideo= null; // Initialize it to a default value, such as null

  }

  ngOnInit(): void {
    this.getCategories();
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.post !== 'undefined') {
      this.event = this.dynamicDialogConfig.data.post;
    }
  if (typeof this.event.id === 'undefined' || this.event.id === null) {
      this.event.id = null;
      this.event.active = false;
  }
    
    this.getEvents();
    this.prepareFrom();
    
  }


  getCategories(){
    this.categoriesDataService.getCategories().subscribe((response: CategoriesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.categories = response.success.data;
      }
    }, (error: any) => {;
     
    });
  }

  getEvents(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.posts !== 'undefined' && this.dynamicDialogConfig.data.posts.length > 0) {
      this.events = this.dynamicDialogConfig.data.posts;
      return;
    }
    this.eventsDataService.getEvents().subscribe((response: EventsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.events = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.eventForm = new FormGroup({
      id: new FormControl(this.event.id, []),
      category: new FormControl(this.categoryValue, [Validators.required, ]),
      title: new FormControl(this.event.title, []),
      // TitleEn: new FormControl(this.event.TitleEn, []),
       titleFr: new FormControl(this.event.titleFr, []),
      picture: new FormControl(this.event.imagePath, []),
      video: new FormControl(this.event.file, []),
      description: new FormControl(this.event.description, []),
      // DescriptionEn: new FormControl(this.event.DescriptionEn, []),
      descriptionFr: new FormControl(this.event.descriptionFr, []),
      date: new FormControl(this.event.date, []),

    });
  }

  onChange(e:any) {
    this.categoryValue = e.value;
  }

  list() {
    this.router.navigate(['/posts']);
  }

  showErrors() {
      const invalidFields: string[] = [];
      Object.keys(this.eventForm.controls).forEach((field: any) => {
        const control = this.eventForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.eventForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.event = this.eventForm.value;
    this.disableSubmit = true;
    this.formData.append('title', this.eventForm ? this.eventForm.value.titleFr : null);
    this.formData.append('titleFr', this.eventForm ? this.eventForm.value.titleFr : null);
    this.formData.append('TitleEn', this.eventForm ? this.eventForm.value.TitleEn : null);
    this.formData.append('description', this.eventForm ? this.eventForm.value.description : null);
    this.formData.append('descriptionFr', this.eventForm ? this.eventForm.value.descriptionFr : null);
    this.formData.append('date', this.eventForm ? this.eventForm.value.date : null);
    this.formData.append('category', this.categoryValue.id);
    if (this.event.id === null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  update(redirect: boolean) {
    this.eventsDataService.updateEvent(this.formData, this.eventForm.value.id).subscribe((data: any) => {
      this.disableSubmit = false;
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      console.warn(error);
    });
  }

  add(redirect: boolean) {
    this.eventsDataService.addEvent(this.formData).subscribe((data: any) => {
        this.disableSubmit = false;
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        console.warn(error);
    });
  }

  uploadPhoto(event: any): void {
    this.selectedFile = event.target.files[0] as File;
    if (this.selectedFile) {
      this.formData.append('picture', this.selectedFile);
    }
  }

  uploadVideo(event: any): void {
    this.selectedVideo = event.target.files[0] as File;
    if (this.selectedVideo) {
      this.formData.append('video', this.selectedVideo);
    }
  }

}

@Component({
  selector: 'app-post-form',
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogEventFormComponent extends EventFormComponent {
}

